import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { Box } from 'reflexbox'
import T from 'i18n-react'

import UploadIconContainer from './UploadIconContainer'
import Subheading from 'components/typography/body2/index'
import NextButton from './NextButton'
import Dropdown from './Dropdown'
import Checkbox from './Checkbox'

import {
  SEGMENT_FILE
} from './constants'

import styles from './styles.scss'

const FileType = (props) => {
  const {
    onNextClick,
    fileType,
    onFileTypeChange,
    onCheck,
    internal,
    segment
  } = props

  return (
    <UploadIconContainer>
      <div styleName='chooseFileHeader'>
        <Subheading>
          Choose File Type
        </Subheading>
      </div>
      <Dropdown
        onChange={onFileTypeChange}
        source={Object.values(SEGMENT_FILE[segment])}
        value={fileType}
      />
      <Checkbox
        theme={styles}
        label={T.translate('containers.project.fileUploadDialog.fileType.checkboxLabel')}
        checked={internal}
        onChange={onCheck}
      />
      <Box auto/>
      <div styleName='progressContainer'>
        <NextButton onClick={onNextClick} label='Next'/>
      </div>
    </UploadIconContainer>
  )
}
const withStyle = CSSModules(styles)
export default withStyle(FileType)
